// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__ZigY3","items":"Skills_items__Cjwm-","content":"Skills_content__vrG4F","focus-items":"Skills_focus-items__4PRzf"};